module.exports = __webpack_public_path__ + "static/media/listofjournals.03ec7dbf.pdf";